<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Pozabljeno geslo</h1>
        <p>Vnesi svoj email in poslali ti bomo navodila za ponastavitev gesla.</p>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <form @submit.prevent="sendEmail">
          <v-layout column>
            <v-flex>
              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model="email"
                required></v-text-field>
            </v-flex>
            <v-flex class="text-xs-center" mt-5>
              <v-btn
                color="primary"
                type="submit"
                @click="login">
                Pošlji sporočilo.
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'resetPassword',
  data() {
    return {
      email: '',
    };
  },

  methods: {
    sendEmail() {
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          console.log('Email sent.');
          this.$router.push('/login');
        })
        .catch((error) => {
          console.log('Error sending email: ', error);
        });
    },
  },
};
</script>
